import Nav from "./components/sections/Nav"
import Hero from "./components/sections/Hero"
import Work from "./components/sections/Work"
import Clients from "./components/sections/Clients"
import About from "./components/sections/About"
import Blog from "./components/sections/Blog"
import Contact from "./components/sections/Contact"
import Links from "./components/sections/Links"
import Footer from "./components/sections/Footer"

const App = () => {
  return (
    <>
      <Nav />
      <Hero />
      {/* <Work /> */}
      <About />
      {/* <Blog /> */}
      {/* Peut être client il passe pour écrire tous les domaines */}
      <Clients />
      <Links />
      <Contact />
      <Footer />
    </>
  )
}

export default App
